import { AppBar, Box, Container, IconButton, Toolbar, useTheme, useMediaQuery, Theme } from '@mui/material';
import MenuIcon from '@mui/icons-material/Menu';
import { Link } from 'react-router';
import { useAppSelector } from '@reduxStore';
import UserAvatar from './UserAvatar';
import TerminalDropdown from './TerminalDropdown';
import { MobileMenuProps } from './types';

import styles from './ApplicationBar.module.css';

export default function ApplicationBar(props: MobileMenuProps) {
	const theme = useTheme();
	const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
	const terminalNumber = useAppSelector((state) => state.applicationState.selectedTerminal?.number);

	return (
		<AppBar
			position='relative'
			sx={{
				bgcolor: theme.palette.grey[200],
				zIndex: theme.zIndex.drawer + 1
			}}
			elevation={0}
		>
			<Container
				maxWidth={false}
				sx={{
					paddingLeft: isMobile ? 0 : ''
				}}
			>
				<Toolbar
					variant='dense'
					disableGutters
				>
					<CompactMenu
						theme={theme}
						{...props}
					/>

					<div className={styles['logo-container']}>
						<Link
							to={`/${terminalNumber ?? ''}`}
							aria-label='Go to home page'
						>
							<img
								src={isMobile ? theme.smallLogoUrl : theme.regularLogoUrl}
								alt='Company/Brand logo'
							/>
						</Link>
					</div>

					<div className={styles['right-justified-items']}>
						<div className={styles['title-bar-container']}>
							<span className={styles['title-bar-content']}>Experienced, Reliable Intermodal Trucking</span>
						</div>

						<div className={styles['flex-items']}>
							<TerminalDropdown />

							<UserAvatar />
						</div>
					</div>
				</Toolbar>
			</Container>
		</AppBar>
	);
}

/**
 * Menu Icon for small resolutions that will eventually trigger the navbar to open full screen
 */
function CompactMenu(props: MobileMenuProps & { theme: Theme }) {
	const { theme } = props;

	return (
		<Box sx={{ display: { xs: 'flex', sm: 'none' } }}>
			<IconButton
				size='large'
				aria-label='account of current user'
				aria-controls='menu-appbar'
				aria-haspopup='true'
				sx={{
					color: theme.palette.text.primary
				}}
				onClick={() => {
					props.setMobileMenuOpen(!props.mobileMenuOpen);
				}}
			>
				<MenuIcon />
			</IconButton>
		</Box>
	);
}
